import React from "react";
import { MemoryRouter } from "react-router-dom";
import Loader from "components/Loader";
import BootEmbeddedForm from "modules/forms/embedded/BootEmbeddedForm";
import { HelmetProvider } from "react-helmet-async";
import * as Sentry from "@sentry/react";
import ErrorHasOccurred from "components/ErrorHasOccured";

// const env = import.meta.env.MODE;
//
// if (env === "production") {
//     Sentry.init({
//         dsn: "https://ec7792a91c1246437fd2e09282461089@o80526.ingest.us.sentry.io/4508517765218304",
//         environment: import.meta.env.MODE,
//         release: import.meta.env.VERSION ?? undefined,
//         ignoreErrors: [
//             ...chunkErrors,
//             "Load failed",
//             "Illegal invocation",
//             "No error message",
//             "NetworkError when attempting to fetch resource.",
//             "Failed to fetch",
//             "ResizeObserver loop completed with undelivered notifications.",
//             'Permission denied to access property "nodeType"', // TinyMCE error.
//             "Non-Error promise rejection captured with value: Object Not Found Matching Id:",
//             "Object captured as exception with keys: message", // Some err related to not being able to load hubspot js
//         ],
//         integrations: [
//             Sentry.thirdPartyErrorFilterIntegration({
//                 // Specify the application keys that you specified in the Sentry bundler plugin
//                 filterKeys: ["custom-sentry-key"],
//
//                 // Defines how to handle errors that contain third party stack frames.
//                 // Possible values are:
//                 // - 'drop-error-if-contains-third-party-frames'
//                 // - 'drop-error-if-exclusively-contains-third-party-frames'
//                 // - 'apply-tag-if-contains-third-party-frames'
//                 // - 'apply-tag-if-exclusively-contains-third-party-frames'
//                 behaviour: "drop-error-if-contains-third-party-frames",
//             }),
//         ],
//     });
// }

export type EmbeddedFormOptions = {
    formId: string,
    portalId?: string,
    onSubmit?: (data: any) => void,
    onError?: (error: any) => void
};

export default function EmbeddedForm(props: EmbeddedFormOptions) {
    return (
        <Sentry.ErrorBoundary fallback={ErrorHasOccurred}>
            <React.Suspense fallback={<Loader/>}>
                <HelmetProvider>
                    <MemoryRouter>
                        <BootEmbeddedForm {...props} formUuid={props.formId}/>
                    </MemoryRouter>
                </HelmetProvider>
            </React.Suspense>
        </Sentry.ErrorBoundary>
    );
}